<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
    locale: {
        type: String,
        default: 'en'
    }
})

const twitterUrl = 'https://twitter.com/Chargemap'

const facebookUrl = 'https://www.facebook.com/Chargemap'

const linkedinUrl = computed(() =>
    props.locale === 'fr'
        ? 'https://fr.linkedin.com/company/chargemap'
        : 'https://linkedin.com/company/chargemap'
)

const instagramUrl = 'https://www.instagram.com/chargemap_com'

const youtubeUrl = 'https://www.youtube.com/channel/UCxAJ3GC2ALldXBuN04eqT7w'
</script>

<template>
    <div class="socials-container">
        <a :href="twitterUrl" title="X Chargemap">
            <IconTwitter />
        </a>
        <a :href="facebookUrl" title="Facebook Chargemap">
            <IconFacebook />
        </a>
        <a :href="instagramUrl" title="Instagram Chargemap">
            <IconInstagram />
        </a>
        <a :href="linkedinUrl" title="LinkedIn Chargemap">
            <IconLinkedin />
        </a>
        <a :href="youtubeUrl" title="YouTube Chargemap">
            <IconYoutube />
        </a>
    </div>
</template>

<style scoped>
.socials-container {
  @apply flex flex-row gap-3 md:gap-2 lg:gap-4 items-center;
}
.socials-container svg {
  @apply text-sky-700 hover:text-sky-500 active:text-sky-700 h-8 w-8 md:w-7 md:h-7;
}
</style>
